import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TradeHistoryLoadingAction, TradeHistoryFailedAction, TradeHistorySuccessAction } from './actions';
import { TradeHistoryState, initialTradeHistoryState } from './state';

const getKey = (year: number, month: number, account: string | undefined) => `${year}-${month}-${account ?? ''}`;

const tradeHistorySlice = createSlice({
  name: 'trade-history',
  initialState: initialTradeHistoryState,
  reducers: {
    reset: () => initialTradeHistoryState,
    loading: (state: TradeHistoryState, action: PayloadAction<TradeHistoryLoadingAction>) => {
      const key = getKey(action.payload.year, action.payload.month, action.payload.account);
      state[key] = {
        error: undefined,
        loading: action.payload.loading,
        loaded: !action.payload.loading,
        trades: state[key]?.trades ?? []
      };
    },
    success: (state: TradeHistoryState, action: PayloadAction<TradeHistorySuccessAction>) => {
      state[getKey(action.payload.year, action.payload.month, action.payload.account)] = {
        error: undefined,
        loading: false,
        loaded: true,
        trades: action.payload.trades
      };
    },
    fail: (state: TradeHistoryState, action: PayloadAction<TradeHistoryFailedAction>) => {
      state[getKey(action.payload.year, action.payload.month, action.payload.account)] = {
        error: action.payload.error,
        loading: false,
        loaded: true,
        trades: []
      };
    }
  }
});

const { actions, reducer } = tradeHistorySlice;
export const { reset, loading, success, fail } = actions;
export default reducer;
